import { render, staticRenderFns } from "./AddRowHeader.vue?vue&type=template&id=0d4cdb5a&"
import script from "./AddRowHeader.vue?vue&type=script&lang=js&"
export * from "./AddRowHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports